/*
 * Minicart js functions
 */
defer('jQuery', () => {
  $(document).ready(function(){
    $("#CartDrawer").on("click", ".ajaxcart__remove-button", function() {
      theme.cart.changeItem($(this).attr("data-cartitem-remove"),0);
      var row = $(this).parent().next().children(".grid__item").children(".js-qty__wrapper");
      row.children(".js-qty__num").val(1);
      row.children(".js-qty__adjust--minus").click();
    });
  });
});